import React from 'react';
import MagicForm from '../../../../Components/Form/MagicForm';
import { userMetaDataSchemes } from './UserMetaDataSchemes';
import { MetaDataItem } from '../../../Manager/Components/Workers/TherapistDetail/TherapistDetail';
import { useCreateUserMetaTranslationMutation } from '../../../../graphql/graphql';
import useMeta from '../../Hooks/useMeta';
import { isString } from 'lodash';

interface Props {
	userId: string;
	metaDataItem: MetaDataItem;
	onSuccess: () => void;
	language?: string;
}

const UserMetaDataEdit: React.FC<Props> = ({
	userId,
	metaDataItem,
	onSuccess,
	language,
}) => {
	const { createUserMeta } = useMeta();
	const [createMetaTranslation] = useCreateUserMetaTranslationMutation();

	const handleValue = (value: string | Record<string, unknown>) => {
		if (isString(value)) {
			return value;
		}
		if (value.html) {
			return value.html;
		}
		return value;
	};

	const handleSubmit = async (values: Record<string, any>) => {
		if (language) {
			const value = handleValue(values[metaDataItem.key]);
			if (!isString(value)) return;
			await createMetaTranslation({
				input: [
					{
						userId: userId,
						key: metaDataItem.key,
						value,
						language: language,
					},
				],
			});
		} else {
			await createUserMeta(
				userId,
				metaDataItem.key,
				handleValue(values[metaDataItem.key]),
			);
		}

		onSuccess();
	};

	if (!metaDataItem) {
		return <></>;
	}

	return (
		<MagicForm
			registerForChanges
			formScheme={userMetaDataSchemes[metaDataItem.key]}
			onSubmit={handleSubmit}
			defaultValues={{ [metaDataItem.key]: metaDataItem.value }}
		/>
	);
};

export default UserMetaDataEdit;
